<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 53.66 53.66">
  <g id="Models" transform="translate(-560.5 -489.701)">
    <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(561 490.201)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    <line id="Line_1908" data-name="Line 1908" x2="12.487" transform="translate(581.543 512.073)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    <g id="Group_27536" data-name="Group 27536" transform="translate(573.879 505.698)">
      <g id="Group_27538" data-name="Group 27538">
        <path id="Path_71020" data-name="Path 71020" d="M1.762,11.992c0-1.062,1.679-3.454,1.679-3.454L1.994,8.1S.984,7.452,1,6.849a1.245,1.245,0,0,1,1.067-1.2L4.6,5.525,7.016,2.467A3.318,3.318,0,0,1,9.417,1L20.3,1a3.318,3.318,0,0,1,2.4,1.467l2.508,3.054,2.532.121A1.245,1.245,0,0,1,28.792,7.06s-.468.93-.979,1.036l-1.481.438s1.716,2.41,1.716,3.5l-1.419,7.3a.982.982,0,0,1-.982.982H22.765a.982.982,0,0,1-.982-.981h0l-.106-1.778H8.337l-.307,1.778h0a.982.982,0,0,1-.982.981H4.165a.982.982,0,0,1-.982-.982Z" transform="translate(-1 -1)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: '#B3B3B3'
    },
    height: {
      type: String,
      default: '53.66px'
    },
    width: {
      type: String,
      default: '53.66px'
    }
  }
}
</script>
<style lang="">

</style>
